import css from "./Header.module.css";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";

const Logo = () => {
  return (
    <Link to="/" className={css.logo}>
      <img className={css.logo_icon} src={logo} alt="logo" />
      <span className={css.logo_text}>Crystal Clear Consulting</span>
    </Link>
  );
};

export default Logo;
